export const cleanCpf = (value?: string | number | null): string =>
  String(value ?? '').replace(/\D/g, '');

export const validateCpf = (value?: string | number | null): boolean => {
  const clean = cleanCpf(value);
  if (!/^\d{11}$/.test(clean)) return false;
  if (/^(\d)\1{10}$/.test(clean)) return false;

  const calcDv = (base: string): number => {
    let sum = 0;
    for (let i = 0; i < base.length; i += 1) {
      sum += Number(base[i]) * (base.length + 1 - i);
    }
    const rest = sum % 11;
    return rest < 2 ? 0 : 11 - rest;
  };

  const dv1 = calcDv(clean.slice(0, 9));
  const dv2 = calcDv(clean.slice(0, 9) + dv1);
  return clean.slice(9) === `${dv1}${dv2}`;
};
